export default __webpack_public_path__ + "static/media/public_col_ico.380f5b4e.svg";